module.exports = __webpack_public_path__ + "be6fcf54ed0caa3376214bb1301ef5d6.png";